<script setup lang="ts">
import AboutUsContent from '~/components/ui/how-it-work-popup-content/AboutUsContent.vue'
import HowItWorkContent from '~/components/ui/how-it-work-popup-content/HowItWorkContent.vue'
import { assetCDN } from '~/helper'

const emits = defineEmits(['close'])
const ASSETS_CDN = assetCDN()
</script>

<template>
  <div class="hp-100">
    <div class="sticky top-0 bg-white z-999" id="header-form" :style="`height:54px`">
      <div class="flex pt-8 pb-4 justify-end items-center px-16">
        <div class="flex items-center px-8 py-8">
          <button @click.prevent="emits('close')">
            <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-close.png`" alt="Close" />
          </button>
        </div>
      </div>
    </div>
    <div class="px-16 overflow-auto" style="height: 500px">
      <p class="fs-18 fw-700 lh-24 mb-4">How it works</p>
      <HowItWorkContent />
      <p class="fs-18 fw-700 lh-24 mb-4">About us</p>
      <AboutUsContent :hasTitle="false" />
    </div>
    <div class="sticky bottom-0 left-0 z-999 wp-100 footer-form px-16 pt-10 pb-7 bg-white">
      <button id="enquiry-form-how-it-work-button-got-it" class="button button-primary wp-100" type="button" @click.prevent="emits('close')">Got it</button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
